import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';

import {
  newCheckInAction,
  newNextAction,
  NEW_NEXT,
  RANDOM_NEXT,
  newRandomNextAction,
} from '../../actions/navigation';

import Header from '../../components/Header';
import Button from '../../components/Button';
import ContentWrapper from '../../components/ContentWrapper';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Footer from '../../components/Footer';
import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';

// Configuration & Assets
import imgPayment from '../../assets/images/payment-red.svg';
import { useConfig } from '../../config/ConfigContext';

const VerifyBank = (props) => {
  const config = useConfig();
  const params = parseUrlParams(window.location.search);
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(0);

  const { checkinData, fetch, navigate, dispatch } = props;
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');

  useEffect(() => {
    if (isEmpty(checkinData)) {
      props.newCheckInAction({
        workflowType,
        key: params.key,
        success: (res) => {
          let routeUrl = get(res, 'data.url');
          if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
            routeUrl = addLusaHeaderParam(routeUrl);
          }
          navigate(routeUrl);
        },
      });
    }
  }, []);

  useEffect(() => {
    if (!get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl'))) {
      let routeUrl = get(checkinData, 'data.url') || get(checkinData, 'state.url');
      if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
        routeUrl = addLusaHeaderParam(routeUrl.replace(config.hostUrl, ''));
      }
      if (fetch.isDone[`${RANDOM_NEXT}`] && !fetch.isRunning[`${RANDOM_NEXT}`]) {
        if (
          get(checkinData, 'data.data.nextAction.path')
          || get(checkinData, 'state.data.nextAction.path')
        ) {
          dispatch(newRandomNextAction({
            rawUrl: get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path'),
            data: {},
          }));
        } else if (get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path')) {
          dispatch(newRandomNextAction({
            rawUrl: get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path'),
            data: {},
          }));
        } else if (routeUrl) {
          navigate(routeUrl);
        }
      } else if (
        fetch.isDone[`${NEW_NEXT}`]
        && !fetch.isRunning[`${NEW_NEXT}`]
      ) {
        if (
          get(checkinData, 'data.data.nextAction.path')
          || get(checkinData, 'state.data.nextAction.path')
        ) {
          dispatch(newRandomNextAction({
            rawUrl: get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path'),
            data: {},
          }));
        } else if (get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path')) {
          dispatch(newRandomNextAction({
            rawUrl: get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path'),
            data: {},
          }));
        } else if (routeUrl) {
          navigate(routeUrl);
        }
      }
    }
  }, [checkinData]);

  const handleButtonClick = (e) => {
    e.preventDefault();

    setIsProgressVisible(true);
    props.newNextAction({
      workflowType,
      key: params.key,
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    });
  };

  return (
    <Transition className="transition-item wrapper v-center">
      <Header navigate={navigate} />
      <ContentWrapper>
        <img src={imgPayment} alt="" />
        <h1>Verify Your Bank Account</h1>
        <p>This is also the bank account you may use if you elect to set up auto-pay.</p>
      </ContentWrapper>
      <Footer>
        <FormRow>
          <FormColumn>
            <Button
              className="btn arrow"
              onClick={handleButtonClick}
              title="Verify Bank Account"
            />
          </FormColumn>
        </FormRow>
      </Footer>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </Transition>
  );
};

VerifyBank.propTypes = {
  dispatch: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  newNextAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  newNextAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyBank);
